import { connect } from 'react-redux';
import { Documentation, IDocumentationProps } from '../../components/Documentation';
import { getDocuments } from '../../selectors/newbuilding';
import { IApplicationState } from '../../types/redux';

type TBuildersStateProps = Pick<IDocumentationProps, 'documentation'>;

export function mapStateToProps(state: IApplicationState): TBuildersStateProps {
  return {
    // @ts-ignore: Поле обязательное, когда поправят свагер, перегенерить схемы и убрать
    documentation: getDocuments(state),
  };
}

export const DocumentationContainer = connect(mapStateToProps)(Documentation);
